<template>
  <div class="main-view blog-post-container">
    <div class="bg-container blog-post-hero ">
      <bg-wave-element></bg-wave-element>
      <div v-if="!post.data" class="flex-row justify-center" :style="{ backgroundImage: `#00A562` }">
        <img src="@/assets/img/icons/loading.gif" alt="">
      </div>
      <div v-else class="blog-post-hero-img template-inner" :style="{ backgroundImage: `url('${ post.data.featured_image }')` }"></div>
    </div>

    <div v-if="!post.data" class="flex-row justify-center">
      loading...
    </div>

    <div class="template-inner" v-else>
      <div class="blog-post-body">
        <div class="post">
          <p class="blog-info">{{ post.data.categories[0].name }}{{'\xa0'}}{{'\xa0'}}|{{'\xa0'}}{{'\xa0'}}{{ post.data.published | moment("MMMM Do YYYY") }}</p>
          <h1 class="post-title">{{ post.data.title }}</h1>
          <div class="post-body" v-html="post.data.body"></div>

          <div class="share-icons">
            <p><strong>Share</strong></p>
            <div class="social-icons">
              <a href="https://linkedin.com/company/getevergrow" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="22.75" height="22.749" viewBox="0 0 22.75 22.749">
                  <path id="Icon_awesome-linkedin-in" data-name="Icon awesome-linkedin-in" d="M5.092,22.75H.376V7.562H5.092ZM2.732,5.49A2.745,2.745,0,1,1,5.463,2.732,2.755,2.755,0,0,1,2.732,5.49ZM22.745,22.75H18.039V15.356c0-1.762-.036-4.022-2.452-4.022-2.452,0-2.828,1.914-2.828,3.895V22.75H8.047V7.562H12.57V9.633h.066A4.956,4.956,0,0,1,17.1,7.181c4.773,0,5.651,3.143,5.651,7.226V22.75Z" transform="translate(0 -0.001)"/>
                </svg>
              </a>
              <a href="https://twitter.com/getevergrow" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="21.117" viewBox="0 0 26 21.117">
                  <path id="Icon_awesome-twitter" data-name="Icon awesome-twitter" d="M23.327,8.643c.017.231.017.462.017.693A15.057,15.057,0,0,1,8.183,24.5,15.058,15.058,0,0,1,0,22.105a11.023,11.023,0,0,0,1.287.066A10.672,10.672,0,0,0,7.9,19.895,5.338,5.338,0,0,1,2.92,16.2a6.72,6.72,0,0,0,1.006.082,5.636,5.636,0,0,0,1.4-.181,5.329,5.329,0,0,1-4.273-5.23V10.8a5.367,5.367,0,0,0,2.409.676,5.337,5.337,0,0,1-1.65-7.127A15.147,15.147,0,0,0,12.8,9.93a6.015,6.015,0,0,1-.132-1.221,5.334,5.334,0,0,1,9.222-3.646,10.491,10.491,0,0,0,3.382-1.287,5.314,5.314,0,0,1-2.343,2.937A10.682,10.682,0,0,0,26,5.888a11.455,11.455,0,0,1-2.673,2.755Z" transform="translate(0 -3.381)" fill="#aaa"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/getevergrow" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.925" height="26" viewBox="0 0 13.925 26">
                  <path id="Icon_awesome-facebook-f" data-name="Icon awesome-facebook-f" d="M14.622,14.625l.722-4.705H10.829V6.866a2.353,2.353,0,0,1,2.653-2.542h2.053V.318A25.031,25.031,0,0,0,11.891,0C8.173,0,5.743,2.254,5.743,6.333V9.92H1.609v4.705H5.743V26h5.087V14.625Z" transform="translate(-1.609)" fill="#aaa"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        
      </div>
    </div>
    <div class="latest-posts">
      <bg-wave-element></bg-wave-element>
      <div class="latest-blog-posts template-inner">
          <h2>Our Latest Posts</h2>
          <div v-if="!latestPosts.data" class="flex-row justify-center">
            <p>loading...</p>
          </div>
          <div class="flex-row align-start" v-else>
            <div class="latest-post one-third" v-for="postLatest in latestPosts.data" :key="postLatest.slug">
              <router-link :to="{ name: 'Resources-Blog-Post', params: { slug: postLatest.slug } }">
                <div class="post-img-holder" :style="{ backgroundImage: `url('${ postLatest.featured_image }')` }"></div>
                <div class="post-copy">
                  <p class="blog-info">{{ postLatest.categories[0].name }}{{'\xa0'}}{{'\xa0'}}|{{'\xa0'}}{{'\xa0'}}{{ postLatest.published | moment("MMMM Do YYYY") }}</p>
                  <h3>{{ postLatest.title }}</h3>
                  <p class="post-summary charcoal">{{ postLatest.summary }}</p>
                  <button class="inverted">read more</button>
                </div>
              </router-link>
            </div>
          </div>
        </div>
    </div>
    <Demo />
  </div>
</template>

<script>
  /* eslint-disable */

  import Butter from 'buttercms'
  // const butter = Butter('4261c88920a47a48ccc3e6f4c8172f6cff6f9b9e');
  const butter = Butter('41fbadec6c80921803218c9e38f7093186c273f5');
  import Demo from "@/components/Demo";

  export default {
    name: 'blog-post',
    data: function() {
      return {
        loading: true,
        post: {},
        latestPosts: []
      }
    },
    components: {
      Demo
    },
    methods: {
      fetchPost () {
        butter.post.retrieve( this.$route.params.slug )
        .then((response) => {
          this.loading = false
          this.post = response.data
          console.log(response.data.data.categories)
        }).catch((response) => {
          // console.log(response)
        })
      },
      fetchLatestPosts () {
        butter.post.list({ page: 1, page_size: 3 })
        .then((response) => {
          this.latestPosts = response.data
        }).catch((response) => {
          console.log(response)
        })
      }
    },
    created () {
      this.fetchPost()
      this.fetchLatestPosts()
    },
    mounted () {
      
    },
    watch: {
      $route: {
        immediate: true,
        handler( to, from ) {
          this.fetchPost()
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .blog-post-container 
    margin-top 117px

  .blog-post-hero
    background-color #D8E9D7
    position relative
    height 600px
    padding 80px 0
    
    .blog-post-hero-img
      position relative

    
  .blog-post-hero-img
    height 600px
    background url() center center / cover no-repeat transparent
    border-radius 20px
    box-shadow 0px 20px 40px #00000033

  .blog-post-body
    max-width 800px
    margin 0 auto

  .post
    margin 150px 0 240px
    
    h1.post-title 
      margin-bottom 40px 
      font-size 52px
      line-height 70px
      

    .post-body
      margin-bottom 60px
      
    .post-body p strong
      font-size 24px
    
    .social-icons
      position relative
      
      a
        display inline-block
        margin-right 40px
      
      svg
        height 26px
        cursor pointer
        & path
          fill #AAA
          transition all 0.125s ease
        &:hover path
          fill #00A562  
  .blog-info
    text-transform capitalize
  .latest-posts  
    background-color #F0F0E4
    padding 40px 0
    position relative
    
    a
      text-decoration none
    
    .post-img-holder
      width 100%
      height 240px
      background-position center center
      background-size cover
      border-radius 20px
      margin-bottom 20px

    .blog-info
      padding-bottom 16px
      
    .post-copy h3 
      font-size 20px
      margin-bottom 20px
    
    svg
      top -180px
      
      path.bg-wave 
        fill #F0F0E4 !important
    
    h2
      text-align center
      margin-bottom 60px 
      
  @media (max-width: 1000px)
    .blog-post-container
      margin-top 90px !important
    .blog-post-hero 
      height 420px
      
      .blog-post-hero-img
        height 240px
        
    .post
      margin-top 80px
      
      h1.post-title
        font-size 40px
        line-height 50px
        
    .post-body p strong 
      line-height 1.5 !important 
        
    .latest-posts svg 
      top -40px
      
    .latest-blog-posts .flex-row
      flex-direction column
      
      .one-third  
        width 100% !important
        margin-bottom 80px
</style>
